import { DialogContent } from "@mui/material";

import BNButton from "../FormElements/BNButton/BNButton";
import CheckIcon from "@mui/icons-material/Check";
import { ICookieConsent } from "./CookieConsentDialog";
import { ICookieConsentDialogStrings } from "./CookieConsentDialog";
import CookieConsentSwitch from "./CookieConsentSwitch";
import { DialogActions } from "@mui/material";
import React from "react";
import { RegionId } from "../../Contract/RegionId";
import BNBox from "../BNBox/BNBox";

interface Props {
  store: (analysis: boolean, marketing: boolean, personalization: boolean) => void;
  strings: ICookieConsentDialogStrings;
  region: RegionId;
  disableCookieConsentForMarketingAndPersonalisation: boolean;
  consent: ICookieConsent;
}

const CookieConstentDialogDetails: React.FC<Props> = (props) => {
  const [state, setState] = React.useState({
    switchPersonalization: props.consent.wantsPersonalization,
    switchMarketing: props.consent.wantsMarketing,
    switchAnalysis: props.consent.wantsAnalysis,
  });

  const storeIt = () => {
    props.store(state.switchAnalysis, state.switchMarketing, state.switchPersonalization);
  };
  const handleSwitchChangeAnalysis = (s: any) => {
    setState({ ...state, switchAnalysis: s });
  };
  const handleSwitchChangePersonalization = (s: any) => {
    setState({ ...state, switchPersonalization: s });
  };
  const handleSwitchChangeMarketing = (s: any) => {
    setState({ ...state, switchMarketing: s });
  };
  return (
    <>
      <DialogContent
        sx={{
          fontSize: "1.2rem",
          mt: 4,
          maxWidth: "48.5rem",
          m: { md: 1 },
        }}
      >
        <BNBox sx={{ fontSize: "2.4rem", py: 0, my: 0.5 }} component={"h3"}>
          {props?.strings?.cookieConsentDialog_HeaderChange}
        </BNBox>
        <CookieConsentSwitch
          header={props?.strings?.cookieConsentDialog_HeaderNecessary}
          force
          description={props?.strings?.cookieConsentDialog_InfoNecessary}
          chandleCheckedChange={() => {}}
          strings={props.strings}
          checked={true}
        />
        <CookieConsentSwitch
          header={props?.strings?.cookieConsentDialog_HeaderAnalysis}
          description={props?.strings?.cookieConsentDialog_InfoAnalysis}
          chandleCheckedChange={handleSwitchChangeAnalysis}
          strings={props.strings}
          checked={state.switchAnalysis}
          dataUit="analysis"
        />
        {!props.disableCookieConsentForMarketingAndPersonalisation && (
          <>
            <CookieConsentSwitch
              header={props?.strings?.cookieConsentDialog_HeaderMarketing}
              description={props?.strings?.cookieConsentDialog_InfoMarketing}
              chandleCheckedChange={handleSwitchChangeMarketing}
              strings={props.strings}
              checked={state.switchMarketing}
              dataUit="marketing"
            />
            <CookieConsentSwitch
              header={props?.strings?.cookieConsentDialog_HeaderPersonalization}
              description={props?.strings?.cookieConsentDialog_InfoPersonalization}
              chandleCheckedChange={handleSwitchChangePersonalization}
              strings={props.strings}
              checked={state.switchPersonalization}
              dataUit="personalization"
            />
          </>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          mx: 2,
          mb: 4,
        }}
      >
        <BNBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          <BNButton variant="outlined" data-uit="store-changes" onClick={storeIt}>
            {props?.strings?.cookieConsentDialog_ButtonStoreChanges}
          </BNButton>
          <BNButton
            startIcon={<CheckIcon />}
            variant="contained"
            color="success"
            onClick={() => {
              props.store(true, true, true);
            }}
          >
            {props?.strings?.cookieConsentDialog_ButtonAcceptAll}
          </BNButton>
        </BNBox>
      </DialogActions>
    </>
  );
};

export default CookieConstentDialogDetails;
